import { defineComponent as t, openBlock as r, createElementBlock as o, mergeProps as s, renderSlot as n } from "vue";
import "./ghl-ui.es220.js";
const l = t({
  name: "UITextLgMedium",
  inheritAttrs: !1
}), m = t({
  ...l,
  setup(a) {
    return (e, i) => (r(), o("div", s(e.$attrs, { class: "hl-text-lg-medium" }), [
      n(e.$slots, "default")
    ], 16));
  }
}), p = m;
export {
  p as default
};
